import { CIDPaginatedResponse } from '@/types/cid';
import { apiClient } from './client';

interface CIDSearchParams {
    q?: string;
    source?: 'cid10' | 'cid11';
    page?: number;
    pageSize?: number;
}

export const cidApi = {
    search: async (params: CIDSearchParams = {}): Promise<CIDPaginatedResponse> => {
        const { q, source = 'cid11', page = 1, pageSize = 50 } = params;

        const response = await apiClient.get<CIDPaginatedResponse>('/cid', {
            params: {
                q: q || undefined,
                source,
                page,
                pageSize,
            },
        });

        return response as unknown as CIDPaginatedResponse;
    },
};
